"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentForm = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _styles = require("./styles");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _check_circle = _interopRequireDefault(require("../../../assets/images/defaultImages/check_circle.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var PaymentForm = function PaymentForm(_ref) {
  var _ref$labelForm = _ref.labelForm,
      labelForm = _ref$labelForm === void 0 ? "Pago con tarjeta" : _ref$labelForm,
      setToken = _ref.setToken,
      setCard = _ref.setCard,
      setStripe = _ref.setStripe,
      setModalErrorCard = _ref.setModalErrorCard,
      setMsj = _ref.setMsj,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected;
  var stripe = (0, _reactStripeJs.useStripe)();
  var elements = (0, _reactStripeJs.useElements)();

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      cardName = _useState2[0],
      setCardName = _useState2[1];

  var _useState3 = (0, _react.useState)({
    name: false,
    number: false,
    cvc: false,
    exp: false
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      valuesComplete = _useState4[0],
      setValuesComplete = _useState4[1];

  var handleIputChange = function handleIputChange(event, key) {
    var temp = (0, _objectSpread2.default)({}, valuesComplete);

    if (key === "name") {
      temp[key] = event === null || event === void 0 ? void 0 : event.length;
      setValuesComplete(temp);
    } else {
      temp[key] = event.complete;
      setValuesComplete(temp);
    }
  };
  /**
   * Este método crea un nuevo token que será enviado a la bd para generar una nueva tarjeta
   */


  var createToken = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var token, _yield$stripe$createP, error, paymentMethod;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /* isNew values
                1: is new
                0: use card existing
                -1: use other payment metoh */
              token = "";
              _context.next = 3;
              return stripe.createToken(elements.getElement(_reactStripeJs.CardNumberElement));

            case 3:
              token = _context.sent;
              _context.next = 6;
              return stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(_reactStripeJs.CardNumberElement),
                billing_details: {
                  name: cardName
                }
              });

            case 6:
              _yield$stripe$createP = _context.sent;
              error = _yield$stripe$createP.error;
              paymentMethod = _yield$stripe$createP.paymentMethod;

              try {
                if (token.token) {
                  token = token.token.id;
                } else {
                  setModalErrorCard && setModalErrorCard(true);
                  setMsj && setMsj(token.error.message);
                }

                paymentMethod.isNew = 1;
                setToken && setToken(token);
                setCard && setCard(paymentMethod);
              } catch (err) {
                console.log(err, error);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createToken() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var valuesArray = Object.values(valuesComplete);
    var allValuesComplete = valuesArray === null || valuesArray === void 0 ? void 0 : valuesArray.every(function (val) {
      return val;
    });
    allValuesComplete ? createToken() : "le falta algo oiga";
    setStripe && setStripe(stripe);
  }, [valuesComplete]);

  var handleCardNameChange = function handleCardNameChange(event) {
    handleIputChange(event.target.value, "name");
    setCardName(event.target.value);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PaymentFormContainer, {
    isSelected: isSelected,
    children: [isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _check_circle.default,
      alt: "Seleccionado"
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: labelForm
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "card-fields",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "element card-name",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Nombre en la tarjeta"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          className: "card-input",
          value: cardName,
          onChange: handleCardNameChange
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "element card-number",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "No. de tarjeta"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactStripeJs.CardNumberElement, {
          className: "card-input",
          onChange: function onChange(e) {
            return handleIputChange(e, "number");
          }
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "element expiration-date",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "Fecha de expiraci\xF3n"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactStripeJs.CardExpiryElement, {
          className: "card-input",
          onChange: function onChange(e) {
            return handleIputChange(e, "exp");
          }
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "element cvc-code ",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          children: "CVC"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactStripeJs.CardCvcElement, {
          className: "card-input",
          onChange: function onChange(e) {
            return handleIputChange(e, "cvc");
          }
        })]
      })]
    })]
  });
};

exports.PaymentForm = PaymentForm;